<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<mat-nav-list class="vertical" style="max-width: 200px">
					<mat-list-item>
						<a
							style="
								text-decoration: none;
								display: flex;
								align-items: center;
								gap: 0.5em;
							"
							[href]="'/' | safeUrl"
							target="_self"
						>
							<mat-icon
								[innerHtml]="'task'"
								fontSet="material-icons"
								[inline]="false"
							></mat-icon>
							<span
								[innerHtml]="'Task List' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</a>
					</mat-list-item>

					<mat-list-item>
						<a [href]="'/' | safeUrl" target="_self">
							<span
								[innerHtml]="'Link 2' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</a>
					</mat-list-item>

					<mat-list-item>
						<a [href]="'/' | safeUrl" target="_self">
							<span
								[innerHtml]="'Link 3' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</a>
					</mat-list-item>
				</mat-nav-list>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
